import { useEffect, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";

import styles from "./DynamicRowTooltip.module.scss";

interface DynamicRowTooltipProps {
  items: string[];
}

const DynamicRowTooltip = ({ items }: DynamicRowTooltipProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [visibleItems, setVisibleItems] = useState<string[]>([]);
  const [hiddenItems, setHiddenItems] = useState<string[]>([]);

  useEffect(() => {
    if (!containerRef.current) return;

    const containerWidth = containerRef.current.clientWidth;
    let totalWidth = 0;
    const visible: string[] = [];
    const hidden: string[] = [];
    const padding = 0;

    const testSpan = document.createElement("span");
    testSpan.style.visibility = "hidden";
    testSpan.style.position = "absolute";
    document.body.appendChild(testSpan);

    items.forEach((item) => {
      testSpan.innerText = item;
      const textWidth = testSpan.offsetWidth + padding;
      if (totalWidth + textWidth < containerWidth - 5) {
        visible.push(item);
        totalWidth += textWidth;
      } else {
        hidden.push(item);
      }
    });

    document.body.removeChild(testSpan);
    setVisibleItems(visible);
    setHiddenItems(hidden);
  }, [items]);

  return (
    <div className={styles.container} ref={containerRef}>
      {visibleItems.map((item, index) => (
        <span key={index} className={styles.item}>
          {item}
        </span>
      ))}
      {hiddenItems.length > 0 && (
        <span
          className={styles.more}
          data-tooltip-id="tooltip"
          data-tooltip-content={hiddenItems.join(", ")}
        >
          +{hiddenItems.length}
        </span>
      )}
      <Tooltip
        id="tooltip"
        place="top"
        style={{ borderRadius: "var(--border-radius)" }}
      />
    </div>
  );
};

export default DynamicRowTooltip;
